import { create } from 'zustand';
import type { SecurityAssessmentResponse, FilterOption } from '../types';

export type SensitivityCategory = 'PII' | 'credentials' | 'financial' | 'health' | 'legal' | 'confidential';

interface SecurityState {
  assessment: SecurityAssessmentResponse | null;
  isLoading: boolean;
  error: string | null;
  selectedOrgId: string | null;
  periodDays: number;
  includeSensitiveAnalysis: boolean;
  selectedSensitivityCategories: SensitivityCategory[];
  availableOrgs: FilterOption[];

  setAssessment: (assessment: SecurityAssessmentResponse) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setSelectedOrgId: (orgId: string | null) => void;
  setPeriodDays: (days: number) => void;
  setIncludeSensitiveAnalysis: (include: boolean) => void;
  setSelectedSensitivityCategories: (categories: SensitivityCategory[]) => void;
  setAvailableOrgs: (orgs: FilterOption[]) => void;
  reset: () => void;
}

export const useSecurityStore = create<SecurityState>((set) => ({
  assessment: null,
  isLoading: false,
  error: null,
  selectedOrgId: null,
  periodDays: 30, // Default to 30 days
  includeSensitiveAnalysis: true,
  selectedSensitivityCategories: ['PII', 'credentials', 'financial', 'health', 'legal', 'confidential'], // Default: all categories
  availableOrgs: [],

  setAssessment: (assessment) => set({ assessment, error: null }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error, isLoading: false }),
  setSelectedOrgId: (selectedOrgId) => set({ selectedOrgId }),
  setPeriodDays: (periodDays) => set({ periodDays }),
  setIncludeSensitiveAnalysis: (includeSensitiveAnalysis) => set({ includeSensitiveAnalysis }),
  setSelectedSensitivityCategories: (selectedSensitivityCategories) => set({ selectedSensitivityCategories }),
  setAvailableOrgs: (availableOrgs) => set({ availableOrgs }),
  reset: () =>
    set({
      assessment: null,
      isLoading: false,
      error: null,
    }),
}));
